import { GetReviewsQuery } from '@/client/graphql/reviews.generated';
import { Flex, useMediaQuery } from '@chakra-ui/react';
import { Rating } from '@meritcircle/ui/components';
import useTranslation from 'next-translate/useTranslation';
import { ReviewCardBox } from '../review-card/components/review-card-box';
import { ReviewCardDate } from '../review-card/components/review-card-date';
import { ReviewCardHeader } from '../review-card/components/review-card-header';
import { ReviewCardBody } from '../review-card/components/review-card-body';

type ReviewSmallCardProps = {
  rating?: number;
  onExpand?: () => void;
  background?: 'filled' | 'transparent';
  isFeatured?: boolean;
} & Pick<GetReviewsQuery['getReviews']['reviews'][0], 'text' | 'createdAt' | 'user'>;

export const ReplyReviewSmallCard = ({
  text,
  createdAt,
  rating,
  user,
  onExpand,
  background = 'filled',
  isFeatured,
}: ReviewSmallCardProps) => {
  const { t } = useTranslation('reviews');
  const [isMobile] = useMediaQuery('(min-width: 48em)');

  const { username, level: userLvl, profilePictureUrl } = user;

  return (
    <ReviewCardBox variant={background}>
      <Flex alignItems="center" gap="space.16" position="absolute" top="space.32" right="space.24">
        {!isFeatured && isMobile && <ReviewCardDate createdAt={createdAt} />}
      </Flex>
      <ReviewCardHeader
        userName={username}
        userLvl={`${t('level')} ${userLvl}`}
        profilePictureUrl={profilePictureUrl}
      />
      {isFeatured || !isMobile || rating ? (
        <Flex flexDirection={isFeatured ? 'column-reverse' : 'column'} gap="space.4">
          <>
            {(isFeatured || !isMobile) && <ReviewCardDate createdAt={createdAt} />}
            {rating ? <Rating rating={rating} showOnlyStars={true} size="md" /> : null}
          </>
        </Flex>
      ) : null}
      <ReviewCardBody reviewText={text} limitHeight={true} onExpand={onExpand} />
    </ReviewCardBox>
  );
};
